module.exports = __webpack_public_path__ + "static/media/videofx_collab-enhanced-300x300.2a951f5f.jpg";